import { useState, useEffect, useRef } from 'react';
import deepEqual from 'fast-deep-equal';
export var SELECTION_MOD;
(function (SELECTION_MOD) {
    SELECTION_MOD["single"] = "single";
    SELECTION_MOD["multi"] = "multi";
})(SELECTION_MOD || (SELECTION_MOD = {}));
export function useSelection(_a) {
    var data = _a.data, selectedIds = _a.selectedIds, _b = _a.idAccessor, idAccessor = _b === void 0 ? function (item) { return item.id; } : _b, _c = _a.mode, mode = _c === void 0 ? SELECTION_MOD.single : _c;
    var prevData = useRef(data);
    var prevSelectedIds = useRef(selectedIds);
    function computeSelected(indexes, ids) {
        var resultState = {
            dataList: [],
            indexList: [],
            idList: []
        };
        var _loop_1 = function (i) {
            if (!indexes.length && !ids.length) {
                return "break";
            }
            var item = data[i];
            if (indexes.length) {
                indexes.forEach(function (index) {
                    if (index === i) {
                        resultState.dataList.push(item);
                        resultState.indexList.push(index);
                        var id = idAccessor(item);
                        if (id || id === 0) {
                            resultState.idList.push(id);
                        }
                    }
                });
            }
            if (ids.length) {
                ids.forEach(function (id) {
                    var itemId = idAccessor(item);
                    if ((itemId || itemId === 0) && itemId === id) {
                        resultState.dataList.push(item);
                        resultState.indexList.push(i);
                        resultState.idList.push(id);
                    }
                });
            }
        };
        for (var i = 0; i < data.length; i++) {
            var state_1 = _loop_1(i);
            if (state_1 === "break")
                break;
        }
        return resultState;
    }
    var _d = useState(computeSelected([], selectedIds || [])), selected = _d[0], setSelected = _d[1];
    var setSelectedIdList = function (result, callback) {
        setSelected(result);
        if (callback) {
            callback(result);
        }
    };
    useEffect(function () {
        if (prevData.current === data && deepEqual(prevSelectedIds.current, selectedIds)) {
            return;
        }
        prevData.current = data;
        prevSelectedIds.current = selectedIds;
        setSelected(computeSelected([], selectedIds || []));
    });
    function mergeIncomingValues(existValues, incomingValues) {
        var resultValues = existValues.slice();
        incomingValues.forEach(function (incomingValue) {
            var foundIndex = resultValues.indexOf(incomingValue);
            if (foundIndex > -1) {
                resultValues.splice(foundIndex, 1);
            }
            else {
                resultValues.push(incomingValue);
            }
        });
        return resultValues;
    }
    var actions = {
        toggleByIndex: function (index, callback) {
            setSelectedIdList(computeSelected(mode === SELECTION_MOD.single
                ? [index]
                : mergeIncomingValues(selected.indexList, [index]), []), callback);
        },
        toggleById: function (id, callback) {
            setSelectedIdList(computeSelected([], mode === SELECTION_MOD.single
                ? [id]
                : mergeIncomingValues(selected.idList, [id])), callback);
        },
        selectAll: function (callback) {
            setSelectedIdList(computeSelected([], data.map(idAccessor)), callback);
        },
        deselectAll: function (callback) {
            setSelectedIdList(computeSelected([], []), callback);
        }
    };
    return [selected, actions];
}
//# sourceMappingURL=useSelection.js.map